/**
 * This custom error class allows the API to send an URI with a displayName to allow users to access.
 */
export class ErrorWithReferenceURI extends Error {
  displayName: string;
  uri: string;

  constructor(message: string, displayName: string, uri: string) {
    super(message);
    this.displayName = displayName;
    this.uri = uri;
  }
}
